import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";

import CheckCircle from "@material-ui/icons/CheckCircle";
import Close from "@material-ui/icons/Close";
import Warning from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";

import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";

import {
  Snackbar as MUISnackbar,
  SnackbarContent,
  IconButton
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

import { closeAlert } from "../../actions";

const Icon = ({ variant, ...props }) => {
  switch (variant) {
    case "success":
      return <CheckCircle {...props} />;
    case "warning":
      return <Warning {...props} />;
    case "error":
      return <ErrorIcon {...props} />;
    default:
      return null;
  }
};

const styles = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: 8
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

let AlertSnackbar = ({
  classes,
  display,
  message,
  variant,
  onClose,
  className,
  ...other
}) => {
  return (
    <MUISnackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      open={display}
      onClose={onClose}
    >
      <SnackbarContent
        className={classNames(classes[variant], className)}
        aria-describedby="alert-snackbar"
        message={
          <span id="alert-snackbar" className={classes.message}>
            <Icon
              variant={variant}
              className={classNames(classes.icon, classes.iconVariant)}
            />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={onClose}
          >
            <Close className={classes.icon} />
          </IconButton>
        ]}
        {...other}
      />
    </MUISnackbar>
  );
};

AlertSnackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  display: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["success", "warning", "error", ""]).isRequired,
  onClose: PropTypes.func
};

const mapStateToProps = state => ({
  display: state.alert.display,
  message: state.alert.message,
  variant: state.alert.variant
});

AlertSnackbar = connect(
  mapStateToProps,
  { onClose: closeAlert }
)(AlertSnackbar);

export default withStyles(styles)(AlertSnackbar);



// WEBPACK FOOTER //
// ./src/components/Snackbar/AlertSnackbar.js